import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/app/services/agentic-bi-potentialanalyse/components/BriefingApp.tsx");
;
import(/* webpackMode: "eager" */ "/usr/app/src/components/features/guide/guide-read-next.css");
;
import(/* webpackMode: "eager" */ "/usr/app/src/components/features/guide/guide-contact.css");
;
import(/* webpackMode: "eager" */ "/usr/app/src/app/toolkit/_shared/briefing.css");
;
import(/* webpackMode: "eager" */ "/usr/app/src/app/toolkit/_shared/briefing-print.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/components/layout/FooterPublic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/components/layout/HeaderPublic.jsx");
